import { Component, forwardRef } from '@angular/core';
import { CheckboxControlValueAccessor, NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

@Component({
  selector: 'kng-switch',
  templateUrl: './kng-switch.component.html',
  styleUrls: [],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => KngSwitchComponent),
      multi: true
    }
  ]
})
export class KngSwitchComponent implements ControlValueAccessor {

  public on: boolean = false;

  constructor() {}

  toggle($event) {
    $event.stopPropagation();

    this.on = ! this.on;
    this.propagateChange(this.on);
  }

  writeValue(value: any) {
    this.on = value;
  }

  registerOnChange(fn) {
    this.propagateChange = fn;
  }

  registerOnTouched() {}

  propagateChange = (_: any) => {};


}



// WEBPACK FOOTER //
// D:/dclean-web-latest/task/cot-web/src/app/layout/kingswell/kng-switch/kng-switch.component.ts